// Google Analytics helpers. Consent state is stored under `calside_consent_v1`
// in localStorage: 'granted' | 'denied' | (absent = no decision yet).
// The GA script + Consent Mode defaults live in /public/index.html.

const CONSENT_KEY = "calside_consent_v1";
const GA_ID = "G-JTR1DTFZ9K";

export function getConsent() {
  try {
    return localStorage.getItem(CONSENT_KEY);
  } catch {
    return null;
  }
}

export function setConsent(value /* 'granted' | 'denied' */) {
  try {
    localStorage.setItem(CONSENT_KEY, value);
  } catch { /* noop */ }
  if (typeof window !== "undefined" && typeof window.gtag === "function") {
    window.gtag("consent", "update", {
      analytics_storage: value === "granted" ? "granted" : "denied",
    });
  }
}

// Fire a page_view. Safe to call on every route change — GA respects the
// current consent state and drops the hit if analytics_storage is denied.
export function trackPageView(pathname, title) {
  if (typeof window === "undefined" || typeof window.gtag !== "function") return;
  window.gtag("event", "page_view", {
    page_path: pathname,
    page_location: window.location.origin + pathname,
    page_title: title || document.title,
    send_to: GA_ID,
  });
}

export { GA_ID, CONSENT_KEY };
